import { useId } from 'react';
import type { TutorExpression } from './TutorAvatar';

/** Existing cloud-bear drawing keeps the Tutor visible if a bundled image fails. */
export function TutorAvatarFallback({ expression }: { expression: TutorExpression }) {
  const gradient = `tuan-tutor-${useId().replaceAll(':', '')}`;
  const smilingEyes = expression === 'greeting';
  const eyebrows = expression === 'thinking' || expression === 'reassuring';
  const eyeHeight = expression === 'listening' ? 15 : 13;
  return (
      <svg className="tutor-face" viewBox="32 24 192 176" focusable="false">
        <defs>
          <linearGradient id={gradient} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="var(--tuan-top)" />
            <stop offset="0.55" stopColor="var(--tuan-middle)" />
            <stop offset="1" stopColor="var(--tuan-bottom)" />
          </linearGradient>
        </defs>
        <g className="tutor-head">
          <circle className="tutor-ear" cx="78" cy="70" r="31" />
          <circle className="tutor-ear" cx="178" cy="70" r="31" />
          <circle className="tutor-inner-ear" cx="78" cy="70" r="15" />
          <circle className="tutor-inner-ear" cx="178" cy="70" r="15" />
          <path
            className="tutor-head-outline"
            fill={`url(#${gradient})`}
            d="M52 124c0-48 31-76 76-76s76 28 76 76c0 36-31 57-76 57s-76-21-76-57Z"
          />
          <path className="tutor-cloud-shine" d="M112 61c8-10 24-10 32 0" />
          {eyebrows && (
            <g className="tutor-eyebrows">
              <path d={expression === 'thinking' ? 'M84 85q10-7 20 0' : 'M84 91l20-6'} />
              <path d={expression === 'thinking' ? 'M152 83l20 5' : 'M152 85l20 6'} />
            </g>
          )}
          <g className="tutor-eyes">
            {smilingEyes ? (
              <g className="tutor-smile-eyes">
                <path d="M84 110q11-14 22 0" />
                <path d="M150 110q11-14 22 0" />
              </g>
            ) : (
              <>
                <ellipse className="tutor-eye-white" cx="95" cy="108" rx="10" ry={eyeHeight} />
                <ellipse className="tutor-eye-white" cx="161" cy="108" rx="10" ry={eyeHeight} />
                <g className="tutor-pupils">
                  <circle cx="97" cy="109" r="5" />
                  <circle cx="163" cy="109" r="5" />
                  <circle className="tutor-eye-shine" cx="99" cy="106" r="2" />
                  <circle className="tutor-eye-shine" cx="165" cy="106" r="2" />
                </g>
              </>
            )}
          </g>
          <ellipse className="tutor-nose" cx="128" cy="133" rx="14" ry="10" />
          {expression === 'explaining' ? (
            <path className="tutor-mouth-open" d="M113 149q15 4 30 0q-3 18-15 18t-15-18Z" />
          ) : expression === 'thinking' ? (
            <path className="tutor-mouth" d="M121 151q8 4 17 0" />
          ) : expression === 'reassuring' ? (
            <path className="tutor-mouth" d="M116 151q12 10 24 0" />
          ) : (
            <path className="tutor-mouth" d="M128 143q-8 14-21 5M128 143q8 14 21 5" />
          )}
          <circle className="tutor-cheek" cx="82" cy="139" r="9" />
          <circle className="tutor-cheek" cx="174" cy="139" r="9" />
        </g>
      </svg>
  );
}
